import React, {Component} from 'react'
import './Select.scss';
import classNames from 'classnames';

class Select extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showMenu: false
    }
  }

  toggleSelect() {
    this.setState({
      showMenu: !this.state.showMenu
    })
  }

  closeSelect() {
    this.setState({
      showMenu: false
    })
  }

  selectOption(item) {
    if (item.scope !== this.props.value) {
      this.props.onSelect(item);
      this.closeSelect()
    }
  }

  formatValue(value) {
    return this.props.formatValue
      ? this.props.formatValue(value)
      : value
  }

  render() {
    return (
      <div className="select theme-sidenav">
        <div className="select-value" onClick={() => this.toggleSelect()}>
          <div>
            {this.props.icon ? <i className={`fa fa-${this.props.icon} icon`}/>: <i className="fa fa-user icon"/>}

            <span className="value"> {this.props.value? this.formatValue(this.props.value): this.props.placeholder}</span>
          </div>
          <i className="fa fa-chevron-down"/>
        </div>
        {
          this.state.showMenu && (
            <div className="select-options">
              {this.props.items.map(item => (
                <div className={classNames('select-option',
                  {'option-selected': item.scope === this.props.value})} key={item.guid}
                     onClick={() => {
                       this.selectOption(item)
                     }}>
                  {this.props.formatValue ? this.formatValue(item.scope) : item.name}
                  <i className="fa fa-check icon-selected"/>
                </div>
              ))}
            </div>
          )
        }

      </div>
    )
  }
}

export default Select
